import React from "react";
import { connect } from "react-redux";
import utils from '../../modules/utils'
import axios from "axios";
import apiInvoker from "../../modules/apiInvoker";
import { trackOppId, trackContactID } from "../../modules/datalayer.js";
import RadioConsensi from '../dati_personali/components/radio_consensi';
import { setRicontattoRichiesto } from "../../actions/index";
import Spinner from "../shared/spinner.js";
import { handleFlow } from '../../flow/flow';
import ModalError from "../shared/modal_errore.js";
import './consensi.css';

const mapDispatchToProps = dispatch => {
  return {
    setRicontattoRichiesto: rr => dispatch(setRicontattoRichiesto(rr))
  };
};

class PrivacyConsensi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      "nome": "",
      "loading": false,
      "errors": ""
    }
    this.handleRadio = this.handleRadio.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    let in_nome = utils.getUrlParameter("nome");
    if (!in_nome || in_nome == "") {
      in_nome = "Gentile cliente";
    } else {
      in_nome = "Ciao " + in_nome + "!";
    }
    this.setState({
      nome: in_nome
    });
  }
  handleRadio(event) {
    event.stopPropagation();
    var radio = event.currentTarget.getElementsByTagName("input")[0];
    radio.checked = true;

    if (radio.name === "valutazione" && radio.value == -1) {
      let errors = this.state.errors;
      errors["valutazione"] = "il consenso è obbligatorio per il prosieguo del processo";
      this.setState({
        [radio.name]: radio.value == 1 ? true : false,
        errors: errors
      });
    } else {
      let errors = this.state.errors;
      delete errors[radio.name];
      this.setState({
        [radio.name]: radio.value == 1 ? true : false,
        errors: errors
      });
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    let self = this;
    self.submitBtn.setAttribute("disabled", "");
    this.setState({
      'loading': true
    })
    let body = {
      'token': utils.getUrlParameter("token"),
      'privacyExtcommoffer': (this.state.informativa ? 1 : 0),
      'privacyOtherservice': (this.state.dati_personali ? 1 : 0),
      'privacyInterncommoffer': (this.state.valutazione ? 1 : 0),
      'privacyProfilazione': (this.state.societa_terze ? 1 : 0)
    }
    apiInvoker.SetPrivacyFromToken(
      body,
      res => {
        self.submitBtn.removeAttribute("disabled");
        this.setState({
          loading: false
        });
        if (res.status == 200) {
          const ws_result = res.data;
          const tracking_url = ws_result.trackingUrl || "";
          if (ws_result.resultCode == 0 || ws_result.resultCode == 200) {
            if (ws_result.oppID) {
              self.props.setOppID(ws_result.oppID);
              trackOppId(ws_result.oppID);
              trackContactID(ws_result.contactID);
            }

            if (tracking_url != "") {
              axios.get(tracking_url);
            }
            self.props.setRicontattoRichiesto(true); //Imposto il ricontatto richiesto per finire nella typ di CLINK
            handleFlow();
          } else {
            if (ws_result.resultCode) {
              utils.showErrorModal(ws_result.resultMessage);
            } else {
              utils.showErrorModal(ws_result.resultMessage);
            }
          }
        }
      })
  }
  render() {
    return (
      <div id="privacy-e-consensi">
        <Spinner
          visible={this.state.loading}
          solid={false}
        />
        <ModalError />
        <div className="panel gsap-slide">
          <h2>{this.state.nome}</h2>
          <form onSubmit={this.handleSubmit} id="form-dati-personali">
            <div className="privacyCompressor">
              <h2 id="ultima-cosa">Un’ultima cosa: abbiamo bisogno del tuo consenso per fissare un appuntamento e valutare l’eventuale richiesta di credito.</h2>
              <h3>
                Esprimi il tuo consenso al trattamento dei dati<br />
                <br />
                Prendi visione delle informative rese da Compass <span className="red-text">ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679</span>,
                della normativa nazionale vigente in materia di protezione dei dati personali e del Codice di condotta per
                i sistemi informativi gestiti da soggetti privati in materia di crediti
                              al consumo affidabilità e puntualità nei pagamenti <a href="/fissa-appuntamento/pdf/COM257F_04_20.pdf" target="_blank">qui scaricabili</a>
              </h3>
              <RadioConsensi
                name="informativa"
                value={this.state.informativa}
                handler={this.handleRadio}
                error={this.state.errors["informativa"]}
                validate="rb"
              />
              <p>
                dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali,
                ivi inclusi i dati relativi all'andamento dei rapporti e i dati relativi all'esposizione
                anche nei confronti delle società del Gruppo Mediobanca, siano trattati da Compass Banca S.p.A
                e da Società appartenenti al Gruppo Mediobanca (direttamente o per il tramite di soggetti terzi),
                            per la finalità indicata alla lettera b) in relazione ai prodotti e servizi propri e di terzi.<br />
                Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
                anche informatici, per verificare la coerenza dei prodotti offerti, in adempimento alle disposizioni di vigilanza.
                          </p>
              <RadioConsensi
                name="dati_personali"
                value={this.state.dati_personali}
                handler={this.handleRadio}
                error={this.state.errors["dati_personali"]}
                validate="rb"
              />
              <p>
                dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano trattati da Compass,
                per la finalità di cui alla lettera e), ovvero per svolgere attività di profilazione consistenti nella individuazione di preferenze,
                gusti, abitudini, necessità e scelte di consumo e nella definizione del profilo dell’interessato, in modo da migliorare i prodotti o
                servizi offerti e soddisfare le esigenze dell’interessato medesimo, nonché per effettuare, previo lo specifico consenso, comunicazioni
                a carattere promozionale, pubblicitario o commerciale personalizzate, con i mezzi indicati nell’informativa.
                          </p>
              <RadioConsensi
                name="societa_terze"
                value={this.state.societa_terze}
                handler={this.handleRadio}
                error={this.state.errors["societa_terze"]}
                validate="rb"
              />
              <p>
                dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali siano comunicati a
                e trattati da Società terze per la finalità indicata alla lettera c) per prodotti o servizi da queste ultime offerti.
                Tale consenso comprende altresì il consenso al trattamento dei propri dati personali mediante l'utilizzo di strumenti,
                anche informativi, per verificare la coerenza dei prodotti offerti, se ed entro gli stretti limiti in cui
                ciò è prescritto dalle disposizioni di vigilanza
                          </p>
              <RadioConsensi
                name="valutazione"
                value={this.state.valutazione}
                handler={this.handleRadio}
                error={this.state.errors["valutazione"]}
                validate="valutazionerb"
              />
              <p>
                dichiarando di aver scaricato e letto le INFORMATIVE, che i miei dati personali, ivi inclusi quelli particolari,
                siano trattati da Compass Banca S.p.A. e comunicati a terzi (e da questi trattati), per le finalità ivi indicate alle lettere
                a) e d) e che Compass acquisisca dalle Società del Gruppo Mediobanca, che quindi potranno trasmettere, i dati relativi
                all'andamento dei rapporti eventualmente intercorrenti con queste ultime e li tratti per finalità strettamente connesse
                alla valutazione del merito creditizio della presente richiesta o per la valutazione di un nuovo rapporto.
                          </p>
            </div>
            <button type="submit" className="bottone" ref={submitBtn => { this.submitBtn = submitBtn }}>
              fissa appuntamento
            </button>
            </form>
        </div>
      </div>
    )
  }
}

export default connect(null, mapDispatchToProps)(PrivacyConsensi);


// WEBPACK FOOTER //
// ./src/components/privacy_consensi/index.js